import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function ContentGrid() {
  const hotCategories = categories.filter((c) =>
    ["Pants / Shorts", "Headwear", "Accessories"].includes(c.name)
  );

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-6 md:px-10 max-w-7xl">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
              Complete Buying Guides
              <br />
              <span className="text-accent-500">&amp; Spreadsheet Tools</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">
            In-depth guides and comparison tools to help you make the most informed product sourcing decisions using spreadsheet-based evaluation methods.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-foreground-900 rounded-2xl p-6 md:p-7 flex flex-col">
            <h3 className="text-lg font-bold font-heading text-white leading-snug">
              OOPBuy Spreadsheet Buying Guide 2025
            </h3>
            <p className="mt-2 text-sm text-foreground-300 leading-relaxed">
              Learn how to read product data and compare suppliers using our comprehensive spreadsheet system. Master the art of efficient product sourcing.
            </p>
            <Link
              to="/article/what-is-oopbuy-spreadsheet"
              className="mt-auto pt-6"
            >
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/10 text-white text-sm font-semibold rounded-full hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap">
                Read Article
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          {hotCategories.slice(0, 2).map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 border border-background-200 rounded-2xl p-6 md:p-7 flex flex-col hover:border-accent-300 transition-all duration-300 cursor-pointer"
            >
              {idx === 0 && (
                <span className="inline-flex items-center gap-1.5 self-start px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-4">
                  <i className="ri-fire-line"></i>
                  Hot
                </span>
              )}
              <div className="w-full aspect-[4/3] rounded-xl overflow-hidden mb-4 bg-background-100">
                <img
                  src={cat.imageUrlSmall}
                  alt={`${cat.name} spreadsheet comparison`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h4 className="text-base font-bold font-heading text-foreground-900">
                {cat.name}
              </h4>
              <p className="mt-1 text-sm text-foreground-500">
                Compare products and find the best deals
              </p>
              <span className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-white text-sm font-semibold rounded-full hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap self-start">
                View Spreadsheet
                <i className="ri-external-link-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}